<template>
  <div class="d-flex w-100">
    <div class="w-15">
      <router-link
        tag="a"
        to="/"
        class="d-flex flex-column ai-center w-20 mt-4 back-link"
      >
        <img
          src="/assets/ic/backstage/info/ic_backstage_info_home.png"
          class="mb-1"
          alt="home"
        />
        <span>{{ $t("homepage") }}</span>
      </router-link>
    </div>
    <div class="flex-1">
      <div class="d-flex flex-column h-100">
        <div class="d-flex flex-column mb-8 mt-2">
          <span style="font-size: 0.85rem;">
            {{ $t("designSelect.content") }}
          </span>
        </div>
        <v-item-group v-model="selected" multiple>
          <div
            class="d-flex flex-wrap overflow-y-overlay"
            style="height: 27.5rem"
          >
            <div class="mr-10 mb-5">
              <v-card
                color="#181C24"
                class="d-flex align-center card-border"
                height="9rem"
                width="14rem"
                :to="`/${this.$i18n.locale}/design/envs`"
                flat
              >
                <div class="flex-grow-1 d-flex jc-center ai-center">
                  <img
                    src="/assets/ic/backstage/status/ic_backstage_status_zoomin.png"
                    alt=""
                  />
                </div>
              </v-card>
            </div>
            <div
              class="mr-10 mb-5"
              v-for="(item, idx) in datas"
              :key="'envs' + idx"
            >
              <v-item v-slot:default="{ active, toggle }">
                <v-hover v-slot:default="{ hover }">
                  <v-card
                    color="#181C24"
                    class="d-flex align-center card-border pa-5"
                    height="9rem"
                    width="14rem"
                    @click="cardClick(toggle, item.orderItemId)"
                    flat
                  >
                    <v-fade-transition>
                      <div
                        v-if="!startAddToCart && hover"
                        class="p-absolute t-0 r-0 mr-2 mt-2"
                        style="z-index: 10;"
                      >
                        <v-btn
                          icon
                          dark
                          @mousedown.stop
                          @click="delOrderItem($event, item.orderItemId)"
                        >
                          <img src="/assets/ic/edit/ic_edit_delete.png" />
                        </v-btn>
                      </div>
                      <div
                        v-if="startAddToCart"
                        class="p-absolute t-0 r-0 mr-2 mt-2"
                      >
                        <v-btn icon dark @mousedown.stop>
                          <img
                            v-if="active"
                            src="/assets/ic/select/ic_select_tick2.png"
                            alt=""
                          />
                          <img
                            v-else
                            src="/assets/ic/select/ic_select_checkbox.png"
                            alt=""
                          />
                        </v-btn>
                      </div>
                    </v-fade-transition>
                    <div class="d-flex w-100 h-100">
                      <v-img :src="item.previewImg" contain></v-img>
                    </div>
                  </v-card>
                </v-hover>
              </v-item>
              <div class="d-flex jc-center mt-3" style="font-size: 0.85rem">
                <span v-if="!item.tagId">
                  {{ $t("designSelect.tagNnonexistent") }}
                </span>
                <span v-else> {{ item.tag.name }} {{ item.update }} </span>
              </div>
            </div>
          </div>
        </v-item-group>
        <div class="p-absolute btn-fixed">
          <v-btn
            class="btn-rounded"
            color="orange"
            min-width="8rem"
            @click="addToCart"
            outlined
            x-large
            depressed
          >
            {{ $t("designSelect.addToCart") }}
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
export default {
  computed: {
    envLocale() {
      if (this.$i18n.locale === "zh-TW") return "nameTW";
      else if (this.$i18n.locale === "zh-CN") return "nameCN";
      else if (this.$i18n.locale === "en") return "nameEN";
      return "nameTW";
    }
  },
  data() {
    return {
      selected: [],
      datas: [],
      startAddToCart: false
    };
  },
  methods: {
    ...mapMutations("environment", ["setEnvIds"]),
    ...mapActions("snackbar", ["openSnackbar"]),
    async getPreview(orderItemId) {
      const res = await this.$http.get(`orderitems/${orderItemId}/preview`);
      return res.data;
    },
    cardClick(toggle, itemId) {
      if (this.startAddToCart) {
        toggle();
        return;
      }
      this.setEnvIds([]);
      this.$router.push(`/${this.$i18n.locale}/design/editor/${itemId}`);
    },
    async delOrderItem(e, orderItemId) {
      e.stopPropagation();
      const confirm = await this.$root.$confirm({
        content: this.$t("designSelect.confirmDelOrderItem"),
        confirmBtn: true,
        cancelBtn: true
      });
      if (!confirm) return;
      await this.$http.delete(`orderItems/${orderItemId}`);
      await this.fetch();
    },
    async addToCart() {
      if (!this.startAddToCart) {
        this.selected.length = 0;
        this.startAddToCart = true;
        return;
      }
      if (this.selected.length === 0) {
        this.startAddToCart = false;
        return;
      }
      const confirm = await this.$root.$confirm({
        content: this.$t("designSelect.confirmAddToCart"),
        confirmBtn: true,
        cancelBtn: true
      });
      if (!confirm) return;
      const cartData = {
        orderItemIds: [],
        inCart: true
      };
      this.selected.forEach(s => {
        cartData.orderItemIds.push(this.datas[s].orderItemId);
      });

      await this.$http.put("orderItems/cart", cartData).then(() => {
        this.openSnackbar({
          msg: this.$t("designSelect.addToCartSuccess"),
          color: "success"
        });
        this.$router.push(`/${this.$i18n.locale}/order/cart`);
      });
    },
    async fetch() {
      const res = await this.$http.get(
        "orderitems?withDetail=true&inCart=false"
      );
      this.datas = res.data.items;
      for (const item of this.datas) {
        await this.$http
          .get(`orderitems/${item.orderItemId}/preview`)
          .then(res => {
            item.previewImg = res.data;
          })
          .catch(err => {
            console.log(err);
          });
      }
      this.$forceUpdate();
    }
  },
  created() {
    this.fetch();
    this.setEnvIds([]);
  }
};
</script>

<style lang="sass" scoped>
.back-link
  user-select: none
  cursor: pointer
  color: #d8d8d8
  font-size: 0.85rem
  > img
    width: 1.5rem
.btn-rounded
  border-radius: 0.5rem
.btn-fixed
  right: 5.2rem
  bottom: 2.3rem
.card-border
  cursor: pointer
  border: 1px solid #979797 !important
</style>
